import { convertDateTimeTo12Hour, convertTo12HourIfNeeded } from "../../services/TimeFormat24hr";

export const getAttendanceReportGenrate = (filters, { allAttendanceRecords = [] }) => {
    const columns = [
        { key: 'member_id', label: 'ID' },
        { key: 'name', label: 'Name' },
        { key: 'role', label: 'Role' },
        { key: 'checkInTime', label: 'Check-in Time', new_key : 'in_time' },
        { key: 'entry_type', label: 'Entry Type', type: 'status' },
    ];
    const filteredRows = allAttendanceRecords.filter(row => {
        const searchLower = filters.search.toLowerCase();
        const date = new Date(row.in_time.replace(" ", "T"));
        const from = filters.dateFrom ? new Date(filters.dateFrom) : null;
        const to = filters.dateTo ? new Date(filters.dateTo) : null;

        if (from) from.setHours(0, 0, 0, 0);
        if (to) to.setHours(23, 59, 59, 999);
        const searchMatch =
            row?.name.toLowerCase().includes(searchLower) ||
            row?.member_id.toLowerCase().includes(searchLower);

        const dateMatch =
            (!from || date >= from) &&
            (!to || date <= to);

        const statusMatch =
            filters.status.length === 0 ||
            filters.status.includes(row.entry_type);

        const trainerMatch =
            filters.trainer.length === 0 ||
            (row.role === 'member' && filters.trainer.includes(row.member_id));

        return searchMatch && dateMatch && statusMatch && trainerMatch;
    });

    const rowData = filteredRows.map(r => ({ ...r, checkInTime: new Date(r.in_time.replace(" ", "T")).toLocaleString(), in_time : r.in_time }));

    return {
        title: 'Attendance Report',
        description: 'Attendance records for members and trainers.',
        columns,
        rows: rowData
    };
};
export const getSessionReport = (filters, { sessionList = [] }) => {
    console.log(sessionList);

    const columns = [
        // { key: 'sessionId', label: 'Session ID' },
        { key: 'memberId', label: 'ID' },
        { key: 'trainerName', label: 'Trainer Name' },
        { key: 'memberName', label: 'Member Name' },
        { key: 'sessionType', label: 'Session Type' },
        { key: 'date', label: 'Date' },
        { key: 'checkInTime', label: 'Check-in Time', new_key: 'in_time' },
        { key: 'status', label: 'Status', type: 'status' },
    ];

    const allSessionRecords = sessionList.map(s => {
        const status = s.status;

        // Check-in Time Fix
        let checkInTime = convertTo12HourIfNeeded(s?.start_time ?? '');

        // Build row
        return {
            sessionId: String(s.id),// no substring; ids are numeric
            memberId: s.user?.member_id ?? 'N/A',            // no substring; ids are numeric 
            trainerName: s.trainer?.name ?? 'N/A',       // nested trainer object
            memberName: s.user?.name ?? 'N/A',           // nested user object
            sessionType: s.plan?.name ?? 'N/A',          // plan name (Gold Plan / Session Plan)
            date: s.date,                                // YYYY-MM-DD (string)
            checkInTime: checkInTime,
            in_time: checkInTime,
            status: status,
        };
    });
    console.log(allSessionRecords);


    // Filters
    const filteredRows = allSessionRecords.filter(row => {
        const searchLower = filters.search.toLowerCase();

        // Date handling
        const from = filters.dateFrom ? new Date(filters.dateFrom) : null;
        const to = filters.dateTo ? new Date(filters.dateTo) : null;

        if (from) from.setHours(0, 0, 0, 0);
        if (to) to.setHours(23, 59, 59, 999);

        const rowDate = new Date(row.date);

        const searchMatch =
            row.memberName.toLowerCase().includes(searchLower) ||
            row.sessionId.toLowerCase().includes(searchLower);

        const dateMatch =
            (!from || rowDate >= from) &&
            (!to || rowDate <= to);

        const statusMatch =
            filters.status.length === 0 || filters.status.includes(row.status);

        const trainerMatch =
            filters.trainer.length === 0 || filters.trainer.includes(row.trainerName);

        const typeMatch =
            filters.sessionType === 'All' || row.sessionType === filters.sessionType;

        return searchMatch && dateMatch && statusMatch && trainerMatch && typeMatch;
    });

    return {
        title: 'Session Attendance Report',
        description: 'Attendance records for specific training sessions.',
        columns,
        rows: filteredRows.map(r => ({
            ...r,
            date: new Date(r.date).toLocaleDateString(), // format for export
        }))
    };
};
 

export const getPaymentHistoryReport = (filters, { paymentList = [] }) => {

    const columns = [
        { key: 'paymentId', label: 'Payment ID' },
        { key: 'memberId', label: 'Member ID' },
        { key: 'memberName', label: 'Member Name' },
        { key: 'membershipType', label: 'Membership Type' },
        { key: 'amount', label: 'Amount (OMR)' },
        { key: 'date', label: 'Date' },
    ];

    const searchLower = filters.search?.toLowerCase() ?? "";
    const membershipFilter = filters.membershipType ?? "All";

    // Convert payment list to rows
    const allPaymentRecords = paymentList.map(p => {
        const rawDate = p.payment_date; // "2025-11-14 17:51:31"

        return {
            _rawDate: rawDate, // for filtering
            paymentId: `#${p.id}`,
            memberId: p.user?.member_id ?? "N/A",
            memberName: p.user?.name ?? "N/A",
            membershipType: p.plan?.name ?? "N/A",
            membershipId: p.plan?.id ?? "N/A",
            amount: p.amount,
            date: new Date(rawDate.replace(" ", "T")).toLocaleString(),
        };
    });
 
    const filteredRows = allPaymentRecords.filter(row => {

        const dateObj = new Date(row._rawDate.replace(" ", "T"));

        // FIXED: avoid timezone issues
        const from = filters.dateFrom ? new Date(filters.dateFrom + "T00:00:00") : null;
        const to = filters.dateTo ? new Date(filters.dateTo + "T23:59:59") : null;

        const searchMatch =
            row.memberName.toLowerCase().includes(searchLower) ||
            row.memberId.toLowerCase().includes(searchLower) ||
            row.paymentId.toLowerCase().includes(searchLower);

        const dateMatch =
            (!from || dateObj >= from) &&
            (!to || dateObj <= to);

        const membershipMatch =
            membershipFilter === "All" ||
            row.membershipType === membershipFilter;

        return searchMatch && dateMatch && membershipMatch;
    });

    return {
        title: "Payment History Report",
        description: "Record of all financial transactions.",
        columns,
        rows: filteredRows
    };
};

export const getMembershipReport = (filters, { membershipList = [] }) => {

    const columns = [ 
        { key: 'memberId', label: 'Member ID' },
        { key: 'memberName', label: 'Member Name' },
        { key: 'plan', label: 'Plan' },
        { key: 'activationDate', label: 'Activation Date' },
        { key: 'renewalDate', label: 'Renewal Date' },
        { key: 'status', label: 'Status', type: 'status' },
    ];

    const searchLower = filters.search?.toLowerCase() ?? "";
    const membershipFilter = filters.membershipType ?? "All";
    const statusFilter = filters.status ?? [];

    // Convert membership list → rows
    const allMembershipRecords = membershipList.map(m => {
        const act = m.activation_date;
        const ren = m.renewal_date;

        return {
            _activationRaw: act,
            _renewalRaw: ren,

            membershipId: `#${m.id}`,
            memberId: m.user?.member_id ?? "N/A",
            memberName: m.user?.name ?? "N/A",
            plan: m.plan_id ?? "N/A",
            status: m.status ?? "N/A",

            activationDate: act ? new Date(act.replace(" ", "T")).toLocaleDateString() : "N/A",
            renewalDate: ren ? new Date(ren.replace(" ", "T")).toLocaleDateString() : "N/A",
        };
    });

    const filteredRows = allMembershipRecords.filter(row => {
        // date objects
        const activationObj = row._activationRaw
            ? new Date(row._activationRaw.replace(" ", "T"))
            : null;

        // from–to date filters (no timezone issues)
        const from = filters.dateFrom
            ? new Date(filters.dateFrom + "T00:00:00")
            : null;
        const to = filters.dateTo
            ? new Date(filters.dateTo + "T23:59:59")
            : null;

        // search match
        const searchMatch =
            row.memberName.toLowerCase().includes(searchLower) ||
            row.memberId.toLowerCase().includes(searchLower) ||
            row.membershipId.toLowerCase().includes(searchLower);

        // date filter applies on activation date
        const dateMatch =
            (!from || (activationObj && activationObj >= from)) &&
            (!to || (activationObj && activationObj <= to));

        // plan filter 
        const planMatch =
            membershipFilter === "All" ||
            row.plan == membershipFilter;
            
        const statusMatch =
            statusFilter.length === 0 || statusFilter.includes(row.status); 
        // const trainerMatch =
        //     trainerFilter.length === 0 || trainerFilter.includes(row.status); 
        
        return searchMatch && dateMatch && planMatch &&statusMatch;
    });

    return {
        title: "Membership Report",
        description: "List of member plan activations and renewals.",
        columns,
        rows: filteredRows
    };
};
